module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"loansIndex":{"amount":{"question":"How much would you like to borrow?","inlineLabel":"Loan amount","subLabel":"You can apply to borrow between €1,000 and €75,000"},"term":{"question":"How many years do you wish to borrow for?","inlineLabel":"Years to borrow","subLabel":"You can apply to borrow between 1 to 10 years"}}}}')
  delete Component.options._Ctor
}
